<template>
    <v-chart :options="calendar" style="width:100%; heigth:100%"/>
</template>
<script>
export default {
    name: "CalendarReport",
    props: ["year"],
    data() {
        return {
            reports: [],
            calendar: {
                title: {                   
                    left: 'center',
                    text: ''
                },
                visualMap: {
                    min: 0,
                    type: "piecewise",
                    inRange: {
                        color: ["#C7DBFF", "#013ADF"]
                    },
                    show: true,
                    orient: "horizontal",
                    left: "center",
                },
                tooltip: {
                    position: "top",
                    formatter: function(p) {
                        return `${p.data[0].toDateString()}: ${p.data[1]} ${
                            p.data[1] == 1 ? "report" : "reports"
                        }`;
                    }
                },
                calendar: {
                    right: 30,
                    cellSize: ["auto", 20],
                    range: this.year? this.year : new Date().getFullYear(),
                    itemStyle: {
                        normal: { borderWidth: 0.5 }
                    },
                    yearLabel: { show: true }
                },
                series: {
                    type: "heatmap",
                    coordinateSystem: "calendar",
                    data: []
                }
            }
        };
    },
    created(){
        this.getData(this.year);
    },
    methods: {
        formatInput(arr) {
            return arr.map( x => {
                return [new Date(x.day), x.count];
            })
        },
        getMaxCount(arr) {
            return Math.max.apply(null, arr.map(x => x.count));
        },
        getData(year){
            //this.calendar.title.text = `Reports of ${year}`;
            this.calendar.calendar.range = year;
            this.$api.getReportsByDay(year).then(response => {
                this.reports = response.data;
            });
        },
    },
    watch: {
        reports(newVal) {
            this.calendar.series.data = this.formatInput(newVal);
            this.calendar.visualMap.max = this.getMaxCount(newVal);
        },
        year(newVal) {
            this.getData(newVal);
        }
    }
};
</script>